export interface MockWishlistItem {
  id: string;
  title: string;
  description: string;
  price_sats: number;
  sats_raised: number;
  product_url: string;
  merchant: string;
  image_url: string;
  currency: string;
  original_price: number;
  is_funded: boolean;
  sort_order: number;
}

export const mockWishlistItems: Record<string, MockWishlistItem[]> = {
  'mock-video-001': [
    {
      id: 'luna-vid-1',
      title: 'Studio Session — Vol. 3',
      description: '4K behind-the-scenes studio video drop',
      price_sats: 50000,
      sats_raised: 32000,
      product_url: '',
      merchant: 'Creator',
      image_url:
        '/images/mock/pexels-85f247453c.jpeg',
      currency: 'USD',
      original_price: 0,
      is_funded: false,
      sort_order: 0,
    },
    {
      id: 'luna-vid-2',
      title: 'Travel Diary — Bali',
      description: 'Exclusive travel video series episode 1',
      price_sats: 75000,
      sats_raised: 75000,
      product_url: '',
      merchant: 'Creator',
      image_url:
        '/images/mock/pexels-d47f70ba4e.jpeg',
      currency: 'USD',
      original_price: 0,
      is_funded: true,
      sort_order: 1,
    },
  ],
  'mock-video-002': [
    {
      id: 'sasha-vid-1',
      title: 'Choreography Reel — Midnight',
      description: 'Premium movement video — members priority',
      price_sats: 42000,
      sats_raised: 28000,
      product_url: '',
      merchant: 'Creator',      image_url: '/images/mock/pexels-48d0ca31b5.jpeg',
      currency: 'USD',
      original_price: 0,
      is_funded: false,
      sort_order: 0,
    },
  ],
  'mock-featured': [
    {
      id: 'item-featured-1',
      title: 'Professional Concrete Ramps',
      description: 'High-quality concrete ramps, bowls, and street obstacles built to professional skateboarding standards',
      price_sats: 2000000,
      sats_raised: 1500000,
      product_url: '',
      merchant: 'Skatepark Construction Co',
      image_url: '/images/mock/pexels-0627eaa705.jpeg',
      currency: 'USD',
      original_price: 2000,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-featured-2',
      title: 'Safety Equipment Bundle (100 sets)',
      description: 'Helmets, knee pads, elbow pads, and wrist guards for program participants',
      price_sats: 1200000,
      sats_raised: 900000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-1f0bba08fb.jpeg',
      currency: 'USD',
      original_price: 1200,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-featured-3',
      title: 'Complete Skateboards (50 units)',
      description: 'Quality beginner-friendly complete skateboards for program participants',
      price_sats: 800000,
      sats_raised: 600000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-8e8235f258.jpeg',
      currency: 'USD',
      original_price: 800,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-featured-4',
      title: 'LED Lighting System',
      description: 'Professional LED lighting system for safe evening skating sessions',
      price_sats: 600000,
      sats_raised: 250000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-e175180aee.jpeg',
      currency: 'USD',
      original_price: 600,
      is_funded: false,
      sort_order: 4,
    },
    {
      id: 'item-featured-5',
      title: 'First Aid Station Equipment',
      description: 'Complete first aid station with medical supplies, ice packs, and emergency equipment',
      price_sats: 400000,
      sats_raised: 0,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-aa4b403fc7.jpeg',
      currency: 'USD',
      original_price: 400,
      is_funded: false,
      sort_order: 5,
    },
  ],
  'mock-001': [
    {
      id: 'item-001-1',
      title: 'Mathematics Textbooks (Set of 25)',
      description: 'Grade 4-6 mathematics textbooks in Spanish for our students',
      price_sats: 400000,
      sats_raised: 150000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-fc4adfb271.jpeg',
      currency: 'USD',
      original_price: 400,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-001-2',
      title: 'Science Textbooks (Set of 25)',
      description: 'Elementary science books covering biology, chemistry, and physics basics',
      price_sats: 400000,
      sats_raised: 100000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-cc85b66a24.jpeg',
      currency: 'USD',
      original_price: 400,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-001-3',
      title: 'Reading Books Set',
      description: 'Collection of 50 age-appropriate reading books in Spanish',
      price_sats: 500000,
      sats_raised: 200000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-eaaafd1b39.jpeg',
      currency: 'USD',
      original_price: 500,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-001-4',
      title: 'School Supplies Bundle',
      description: 'Notebooks, pencils, erasers, rulers for 50 students',
      price_sats: 300000,
      sats_raised: 0,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-9edbeb2b48.jpeg',
      currency: 'USD',
      original_price: 300,
      is_funded: false,
      sort_order: 4,
    },
  ],
  'mock-002': [
    {
      id: 'item-002-1',
      title: 'Yamaha FG800 Acoustic Guitar',
      description: 'Professional solid top acoustic guitar with excellent tone and projection',
      price_sats: 900000,
      sats_raised: 550000,
      product_url: 'https://www.amazon.com/Yamaha-FG800-Dreadnought-Natural/dp/B01DS3L3HO',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-5e89e84d08.jpeg',
      currency: 'USD',
      original_price: 900,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-002-2',
      title: 'Guitar Strings 6-Pack',
      description: 'D\'Addario phosphor bronze acoustic guitar strings',
      price_sats: 60000,
      sats_raised: 60000,
      product_url: 'https://www.amazon.com/DAddario-EJ16-Phosphor-Bronze-Acoustic-Guitar-Strings/dp/B000EEJ8CS',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-fae5ab023a.jpeg',
      currency: 'USD',
      original_price: 60,
      is_funded: true,
      sort_order: 2,
    },
    {
      id: 'item-002-3',
      title: 'Guitar Case',
      description: 'Hard shell protective case for acoustic guitar',
      price_sats: 100000,
      sats_raised: 40000,
      product_url: 'https://www.amazon.com/Gator-Foam-Padded-Acoustic-Guitar-Gig-Bag/dp/B000N4WHYK',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-beab903d8f.jpeg',
      currency: 'USD',
      original_price: 100,
      is_funded: false,
      sort_order: 3,
    },
  ],
  'mock-003': [
    {
      id: 'item-003-1',
      title: 'First Aid Kits (10x Complete)',
      description: 'Comprehensive first aid kits with 200+ essential medical items',
      price_sats: 800000,
      sats_raised: 300000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-1433844d9b.jpeg',
      currency: 'USD',
      original_price: 800,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-003-2',
      title: 'Digital Thermometers (20x)',
      description: 'Fast-read digital thermometers for accurate temperature readings',
      price_sats: 200000,
      sats_raised: 150000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-aa4b403fc7.jpeg',
      currency: 'USD',
      original_price: 200,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-003-3',
      title: 'Blood Pressure Monitors (5x)',
      description: 'Automatic digital blood pressure monitors with large displays',
      price_sats: 400000,
      sats_raised: 200000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-7544615394.jpeg',
      currency: 'USD',
      original_price: 400,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-003-4',
      title: 'Stethoscopes Professional (10x)',
      description: 'High-quality stethoscopes for medical examinations',
      price_sats: 600000,
      sats_raised: 240000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-aa4b403fc7.jpeg',
      currency: 'USD',
      original_price: 600,
      is_funded: false,
      sort_order: 4,
    },
  ],
  'mock-004': [
    {
      id: 'item-004-1',
      title: 'Dell Inspiron 15 Laptop',
      description: '15.6" FHD, Intel i5, 8GB RAM, 256GB SSD - Perfect for coding',
      price_sats: 1100000,
      sats_raised: 300000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-1a16f86d64.jpeg',
      currency: 'USD',
      original_price: 1100,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-004-2',
      title: 'Laptop Backpack',
      description: 'Protective laptop backpack with multiple compartments',
      price_sats: 50000,
      sats_raised: 20000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-f741aae3b9.jpeg',
      currency: 'USD',
      original_price: 50,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-004-3',
      title: 'Wireless Mouse',
      description: 'Ergonomic wireless mouse for programming',
      price_sats: 30000,
      sats_raised: 0,
      product_url: 'https://www.amazon.com/Logitech-Wireless-Mouse/dp/B003NR57BY',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-577441d9bf.jpeg',
      currency: 'USD',
      original_price: 30,
      is_funded: false,
      sort_order: 3,
    },
  ],
  'mock-005': [
    {
      id: 'item-005-1',
      title: 'Water Well Drilling Equipment',
      description: 'Professional drilling equipment to reach underground water sources',
      price_sats: 1500000,
      sats_raised: 800000,
      product_url: '',
      merchant: 'Industrial Supply Co',
      image_url: '/images/mock/pexels-986cc82443.jpeg',
      currency: 'USD',
      original_price: 1500,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-005-2',
      title: 'Water Pump System',
      description: 'Solar-powered water pump to bring water to the surface',
      price_sats: 800000,
      sats_raised: 400000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-b730f52a6d.jpeg',
      currency: 'USD',
      original_price: 800,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-005-3',
      title: 'Water Storage Tank (5000L)',
      description: 'Large capacity water storage tank for the community',
      price_sats: 400000,
      sats_raised: 150000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-48d0ca31b5.jpeg',
      currency: 'USD',
      original_price: 400,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-005-4',
      title: 'Water Filtration System',
      description: 'Complete filtration system to ensure clean drinking water',
      price_sats: 300000,
      sats_raised: 100000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-5a4ba8a5c1.jpeg',
      currency: 'USD',
      original_price: 300,
      is_funded: false,
      sort_order: 4,
    },
  ],
  'mock-006': [
    {
      id: 'item-006-1',
      title: 'Adobe Creative Cloud (Annual)',
      description: 'Full Adobe Creative Suite subscription for design work',
      price_sats: 600000,
      sats_raised: 400000,
      product_url: 'https://www.adobe.com/creativecloud.html',
      merchant: 'Adobe',
      image_url: '/images/mock/pexels-7430c3f2c8.jpeg',
      currency: 'USD',
      original_price: 600,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-006-2',
      title: 'Wacom Drawing Tablet',
      description: 'Professional drawing tablet for digital illustration and design',
      price_sats: 150000,
      sats_raised: 120000,
      product_url: 'https://www.amazon.com/Wacom-Intuos-Pro-Digital-Tablet/dp/B079HL9YSF',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-3afbbfc6a7.jpeg',
      currency: 'USD',
      original_price: 150,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-006-3',
      title: 'External Monitor 27"',
      description: '4K monitor for better design workflow and productivity',
      price_sats: 50000,
      sats_raised: 40000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-85f247453c.jpeg',
      currency: 'USD',
      original_price: 50,
      is_funded: false,
      sort_order: 3,
    },
  ],
  'mock-007': [
    {
      id: 'item-007-1',
      title: 'Trail Camera (12 units)',
      description: 'High-resolution wildlife cameras with night vision and motion detection',
      price_sats: 900000,
      sats_raised: 650000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-986cc82443.jpeg',
      currency: 'USD',
      original_price: 900,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-007-2',
      title: 'SD Cards (24x 128GB)',
      description: 'High-capacity SD cards for storing camera trap footage',
      price_sats: 200000,
      sats_raised: 180000,
      product_url: 'https://www.amazon.com/SanDisk-128GB-SD-Card/dp/B073JYC4XM',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-bbed3f8ad4.jpeg',
      currency: 'USD',
      original_price: 200,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-007-3',
      title: 'Solar Panel Kits',
      description: 'Solar charging kits to power cameras in remote locations',
      price_sats: 300000,
      sats_raised: 200000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-0bd06f077a.jpeg',
      currency: 'USD',
      original_price: 300,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-007-4',
      title: 'Weatherproof Cases',
      description: 'Protective cases for cameras in harsh outback conditions',
      price_sats: 100000,
      sats_raised: 70000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-cde9b429e8.jpeg',
      currency: 'USD',
      original_price: 100,
      is_funded: false,
      sort_order: 4,
    },
  ],
  'mock-008': [
    {
      id: 'item-008-1',
      title: 'Organic Seeds Collection',
      description: 'Variety pack of organic vegetable and herb seeds for urban garden',
      price_sats: 150000,
      sats_raised: 130000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-2f537750d8.jpeg',
      currency: 'USD',
      original_price: 150,
      is_funded: false,
      sort_order: 1,
    },
    {
      id: 'item-008-2',
      title: 'Garden Tools Set',
      description: 'Complete set of essential gardening tools for community use',
      price_sats: 200000,
      sats_raised: 180000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-63d6ce3f6c.jpeg',
      currency: 'USD',
      original_price: 200,
      is_funded: false,
      sort_order: 2,
    },
    {
      id: 'item-008-3',
      title: 'Raised Bed Materials',
      description: 'Lumber and materials for building 15 raised garden beds',
      price_sats: 150000,
      sats_raised: 120000,
      product_url: '',
      merchant: 'Home Depot',
      image_url: '/images/mock/pexels-5b9562dd2f.jpeg',
      currency: 'USD',
      original_price: 150,
      is_funded: false,
      sort_order: 3,
    },
    {
      id: 'item-008-4',
      title: 'Composting System',
      description: 'Large composting bins and starter materials for waste reduction',
      price_sats: 100000,
      sats_raised: 50000,
      product_url: '',
      merchant: 'Amazon',
      image_url: '/images/mock/pexels-45c4be1ad1.jpeg',
      currency: 'USD',
      original_price: 100,
      is_funded: false,
      sort_order: 4,
    },
  ],
};

export const mockWishlists = [
  {
    id: 'mock-001',
    title: 'Maya — Reading Club, Antigua',
    description: 'Weekly read-along videos from a highland classroom. Sats buy the book sets my students share and fund the next episode.',
    created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I teach 50 students in the highlands outside Antigua, Guatemala, and every week I film a read-along with them.

We started posting the sessions so families who had moved away could still follow along. The videos now reach a few thousand viewers, and that is the whole business: people watch, and if it is useful to them they send sats.

This wishlist pays for the books we read on camera. Right now our 50 students share ten outdated textbooks between them, and many of them walk up to two hours to reach the school. Funded items go straight into the classroom library, and the next read-along happens the following week.

Nothing here needs a bank, an advertiser, or a platform that takes a cut of the work. Every sat a viewer sends arrives in my own wallet, and every funded book shows up in the next episode.`,
    slug: 'maya-reading-club',
    cover_image: '/images/mock/pexels-b67b196f53.jpeg',
    total_sats_goal: 1600000,
    total_sats_raised: 450000,
    country: 'Guatemala',
    country_code: 'GT',
    country_flag: '🇬🇹',
    city: 'Antigua',
    latitude: 14.5586,
    longitude: -90.7339,
    creator: {
      username: 'maya_reads',
      avatar_url: null,
      bio: 'Teacher · reading club · filming the classroom in Antigua, Guatemala.',
    },
  },
  {
    id: 'mock-002',
    title: 'Paul — First Independent EP',
    description: 'Six days a week on Broadway, recording a first EP between sets. Funding the instrument, the studio days, and the release.',
    created_at: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I play six days a week on Broadway in Nashville. I have been busking for five years and posting the sets online for two, and that audience is the reason recording is possible at all.

The EP is half written. What it needs now is an instrument that holds tuning, a few proper studio days, and someone to mix it. This wishlist is that budget, item by item.

I would rather take support directly from the people listening than hand a fifth of it to a distributor that does not know or care about the songs. Sats land in my wallet, and backers get the rough cuts and stems as they are finished.

Nothing here is a handout request. I play every day. This is the cheapest honest way to get the songs recorded properly.`,
    slug: 'paul-first-ep',
    cover_image: '/images/mock/pexels-5e89e84d08.jpeg',
    total_sats_goal: 1000000,
    total_sats_raised: 650000,
    country: 'United States',
    country_code: 'US',
    country_flag: '🇺🇸',
    city: 'Nashville',
    latitude: 36.1627,
    longitude: -86.7816,
    creator: {
      username: 'paul_music',
      avatar_url: null,
      bio: 'Street musician recording a first independent EP, funded one song at a time.',
    },
  },
  {
    id: 'mock-003',
    title: 'Dr. Omondi — Field Diaries',
    description: 'Documentary shorts from a rural clinic outside Nairobi. Funding clinic supplies on camera, one patient story at a time.',
    created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I run a clinic outside Nairobi that is the only medical facility within 30 kilometres. We see around 80 patients a day, and for the past year I have been filming what that actually looks like.

The Field Diaries are short documentary pieces: a mother in labour, a child with malaria, the week we ran out of antibiotics. Nothing staged and nothing softened.

Publishing them changed something. Viewers started asking how to help, so this wishlist is the answer: first aid kits, thermometers, monitors, stethoscopes. Everything funded here goes into the clinic, and the delivery shows up in the next episode.

100% of what you send reaches the clinic. Our small volunteer staff do not take a share of the supplies.`,
    slug: 'omondi-field-diaries',
    cover_image: '/images/mock/pexels-1e4c9eed79.jpeg',
    total_sats_goal: 2400000,
    total_sats_raised: 890000,
    country: 'Kenya',
    country_code: 'KE',
    country_flag: '🇰🇪',
    city: 'Nairobi',
    latitude: -1.2864,
    longitude: 36.8172,
    creator: {
      username: 'omondi_field',
      avatar_url: null,
      bio: 'Rural clinic doctor · documentary shorts from outside Nairobi, Kenya.',
    },
  },
  {
    id: 'mock-004',
    title: 'Maria Codes — Live Build Series',
    description: 'Learning in public from São Paulo: live build streams, free notes and code, and a workstation so I can ship daily.',
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I am 19 and I learned to code at a free workshop in Sao Paulo. Two years later I stream the builds I am learning from, because that is how I learned in the first place.

Until now I have worked from the public library and internet cafes, which caps me at a few hours a week. This wishlist is the workstation: a laptop, a bag to move it in, a mouse, and the small things that let me stream consistently.

Every stream is free to watch, and I publish the notes and the code afterwards. If the builds are useful to you, send sats and the next one happens sooner.

Sample content: this is a demo creator profile used to show how Katoa works.`,
    slug: 'maria-codes-live',
    cover_image: '/images/mock/pexels-a413517b26.jpeg',
    total_sats_goal: 1200000,
    total_sats_raised: 320000,
    country: 'Brazil',
    country_code: 'BR',
    country_flag: '🇧🇷',
    city: 'São Paulo',
    latitude: -23.5505,
    longitude: -46.6333,
    creator: {
      username: 'maria_codes',
      avatar_url: null,
      bio: 'Building in public from São Paulo · live streams, notes, and open code.',
    },
  },
  {
    id: 'mock-005',
    title: 'Water4Life — Well Documentary',
    description: 'Filming a village borehole from survey to first water. Sats fund the drilling and the crew that documents it.',
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `Oke Village has 300 people and no clean water. The nearest source is five kilometres away, and mostly it is women and children who walk it twice a day.

We are filming the whole project: the survey, the drilling to 60 metres, the hand pump going in, and the village committee we train to maintain it. The documentaries are how the work gets funded.

This wishlist is the drilling and documentation budget - equipment, storage, and the crew time to keep filming until water is flowing. Everything funded is shown on camera, and supporters can follow the build to the day the pump is tested.

No middleman holds this money. Sats arrive, the crew films the next stage, and the village keeps the well.`,
    slug: 'water4life-well-documentary',
    cover_image: '/images/mock/pexels-8dcf89cf64.jpeg',
    total_sats_goal: 3000000,
    total_sats_raised: 1450000,
    country: 'Nigeria',
    country_code: 'NG',
    country_flag: '🇳🇬',
    city: 'Lagos',
    latitude: 6.5244,
    longitude: 3.3792,
    creator: {
      username: 'water4life',
      avatar_url: null,
      bio: 'Documenting a village well from survey to first water, for Oke Village.',
    },
  },
  {
    id: 'mock-006',
    title: 'AccessTech Tokyo — Build in Public',
    description: 'Three developers building a screen reader and streaming the process. Sats fund the design tools and the path to release.',
    created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `We are three developers in Tokyo building VoiceNav, a screen reader that describes digital content in plain language. Our lead developer is blind, and she is the reason the product exists at all.

We stream the build: design reviews, accessibility testing, and the parts that do not work the first time. 50 beta users are already on it, and their feedback has been overwhelmingly positive.

This wishlist covers the studio costs - design software, a drawing tablet, and a reference display for design reviews. There is no venture money here and no platform taking a cut of it.

In Japan alone there are over 300,000 people with visual impairments. Every funded tool moves the public release closer.`,
    slug: 'accesstech-build-in-public',
    cover_image: '/images/mock/pexels-02110df489.jpeg',
    total_sats_goal: 800000,
    total_sats_raised: 560000,
    country: 'Japan',
    country_code: 'JP',
    country_flag: '🇯🇵',
    city: 'Tokyo',
    latitude: 35.6762,
    longitude: 139.6503,
    creator: {
      username: 'accessible_tech',
      avatar_url: null,
      bio: 'Building VoiceNav in public · accessibility first, from Tokyo.',
    },
  },
  {
    id: 'mock-007',
    title: 'Steve — Outback Camera Traps',
    description: 'Twelve years of wildlife monitoring, filmed in the field. Sats fund the cameras watching 50,000 acres.',
    created_at: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I have worked wildlife in the Australian Outback for twelve years, and for the last three I have been filming the field work. Camera traps are how we see almost everything: Bilbies, Stick-nest Rats, and the bird populations behind them.

Posting the footage made the work visible, and viewers started funding replacement cameras. This wishlist is that, line by line: twelve traps with night vision, cards, solar, and cases rated for the heat.

Last year the traps caught a new threat to the local Bilbies early enough to intervene. That is what this buys: eyes on 50,000 acres, all year round.

We are a small crew running on passion and minimal funding. Every sat goes to the equipment, and the footage is free for anyone to watch.`,
    slug: 'outback-camera-traps',
    cover_image: '/images/mock/pexels-2f3dc89a68.jpeg',
    total_sats_goal: 1500000,
    total_sats_raised: 1100000,
    country: 'Australia',
    country_code: 'AU',
    country_flag: '🇦🇺',
    city: 'Sydney',
    latitude: -33.8688,
    longitude: 151.2093,
    creator: {
      username: 'aussie_wildlife',
      avatar_url: null,
      bio: 'Wildlife field work in the Australian Outback, filmed as it happens.',
    },
  },
  {
    id: 'mock-008',
    title: 'Anna — Neukölln Garden Club',
    description: 'A grow-along series from a Berlin community plot. Sats buy the seeds, tools, and beds 30 families plant in.',
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `I organise a community garden in Neukoelln with 30 families. We have a 500 square metre plot and a waiting list, and last spring I started filming the whole season as a grow-along.

The series is practical: what to plant when, what failed, and how to keep a compost going in an apartment block. Kids who have never pulled a carrot out of soil are in most of the episodes.

This wishlist pays for the season - seeds, tools, timber for the raised beds, the greenhouse, and the teaching materials. Funded items appear in the episodes they were bought for.

The garden is a shared resource, not a shop. Sats cover the supplies, and the harvest goes to the families who planted it.`,
    slug: 'neukoelln-garden-club',
    cover_image: '/images/mock/pexels-5b9562dd2f.jpeg',
    total_sats_goal: 600000,
    total_sats_raised: 480000,
    country: 'Germany',
    country_code: 'DE',
    country_flag: '🇩🇪',
    city: 'Berlin',
    latitude: 52.5200,
    longitude: 13.4050,
    creator: {
      username: 'berlin_green',
      avatar_url: null,
      bio: 'Community garden organiser · grow-along series from Neukölln, Berlin.',
    },
  },
  {
    id: 'mock-featured',
    title: 'Skateboard Park for Medellín Youth',
    description: 'Transform lives through skateboarding. Building a safe community space where 500+ youth can skate, learn, and grow together with free lessons and mentorship.',
    created_at: '2025-11-01T08:00:00Z',
    full_story: `¡Hola! I'm Carlos Ramirez, founder of Skate Colombia Foundation. For the past eight years, I've dedicated my life to using skateboarding as a tool for social change in Medellín, Colombia.

Growing up in Comuna 13, one of Medellín's most challenging neighborhoods, I witnessed firsthand how limited opportunities and lack of safe spaces affect young people. Skateboarding saved my life—it gave me purpose, discipline, and a positive community when I needed it most.

Now, I want to create that same opportunity for the next generation. We're building a full-scale skatepark in the heart of Comuna 13 that will serve over 500 youth. This isn't just about building ramps—it's about building futures.

Our program includes:
• Free skateboarding lessons for beginners (ages 8-18)
• Weekly workshops on life skills, conflict resolution, and goal setting
• Mentorship program pairing experienced skaters with newcomers
• Scholarship opportunities for talented skaters to compete nationally
• Safe space open 6 days a week, supervised by trained staff

We've already secured the land (donated by the city) and gathered a team of 15 volunteer instructors. We've also partnered with local schools to identify youth who would benefit most from the program.

The funds we're raising will cover:
• Construction of professional-grade concrete ramps and bowls
• Safety equipment (helmets, pads) for 100+ participants
• Basic skateboards for program participants
• Lighting for evening sessions
• First aid station and emergency equipment

Skateboarding taught me that falling is part of learning, but getting back up is what defines you. Every donation helps us create a space where kids learn this invaluable lesson while staying away from negative influences.

We're 65% funded and construction is ready to begin! Your support will directly impact hundreds of young lives. ¡Gracias por su apoyo!`,
    slug: 'medellin-skate-park',
    cover_image: '/images/mock/pexels-2a6bfc8ddf.jpeg',
    cover_video_url: 'https://videos.pexels.com/video-files/9724317/9724317-sd_480_360_30fps.mp4',
    total_sats_goal: 5000000,
    total_sats_raised: 3250000,
    country: 'Colombia',
    country_code: 'CO',
    country_flag: '🇨🇴',
    city: 'Medellín',
    latitude: 6.2476,
    longitude: -75.5658,
    creator: {
      username: 'skate_colombia',
      avatar_url: null,
      lightning_address: 'carlos@getalby.com',
      bio: 'Founder of Skate Colombia Foundation. Using skateboarding to empower youth in Medellín. Former pro skater, now full-time social entrepreneur.',
    },
  },
  {
    id: 'mock-video-001',
    title: 'Luna — Exclusive Video Collection',
    description:
      'Premium behind-the-scenes video drops and VIP creator content. Tip in sats — 0% platform fees, Lightning instant.',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `Hey, I'm Luna — independent creator building a direct fan economy on Bitcoin Lightning.

This wishlist funds exclusive video series: studio sessions, travel diaries, and members-only drops you won't find on ad-supported platforms. No payment processor holding your tips — sats land in my wallet instantly.

Supporters unlock early access to new videos and vote on the next shoot themes. 100% of tips go to production gear, editing, and keeping the content uncensored by banks.`,
    slug: 'luna-exclusive-videos',
    card_style: 'creator',
    category: 'creator',
    cover_image:
      '/images/mock/pexels-7867fa1faf.jpeg',
    cover_video_url:
      'https://videos.pexels.com/video-files/4058851/4058851-hd_720_1280_25fps.mp4',
    total_sats_goal: 2500000,
    total_sats_raised: 1840000,
    subscriber_count: 1284,
    country: 'United States',
    country_code: 'US',
    country_flag: '🇺🇸',
    city: 'Los Angeles',
    latitude: 34.0522,
    longitude: -118.2437,
    creator: {
      username: 'luna_vip',
      avatar_url: null,
      bio: 'Video creator · VIP drops · Bitcoin-native monetization',
    },
  },
  {
    id: 'mock-video-002',
    title: 'Sasha — VIP Video Wishlist',
    description:
      'Sensual movement & premium video content — subscribe with Lightning. Keep creators paid, not platforms.',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    full_story: `Sasha here — dancer and visual storyteller going direct-to-fan on KATOA.

Fund my next video series: choreography reels, golden-hour shoots, and intimate studio sessions. Every sat supports independent adult-friendly art without OnlyFans taking 20%.

Lightning tips = instant access to drop notifications and custom thank-you clips. Your keys, your privacy, my creative freedom.`,
    slug: 'sasha-vip-content',
    card_style: 'creator',
    category: 'creator',
    cover_image:
      '/images/mock/pexels-b7f18dd14d.jpeg',
    cover_video_url:
      'https://videos.pexels.com/video-files/3195394/3195394-sd_640_360_30fps.mp4',
    total_sats_goal: 1800000,
    total_sats_raised: 920000,
    subscriber_count: 876,
    country: 'United Kingdom',
    country_code: 'GB',
    country_flag: '🇬🇧',
    city: 'London',
    latitude: 51.5074,
    longitude: -0.1278,
    creator: {
      username: 'sasha_vip',
      avatar_url: null,
      bio: 'Movement artist · Premium video · 0% fee Lightning payouts',
    },
  },
];
